export default __webpack_public_path__ + "static/char-s-10-cht-ec4e680339b1b1b06eee35d39f5c67d1.webp";